// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */
.modalOverlay_RR__W {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_00000066-background);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: opacity 300ms ease-in-out;
}

.modalContent_z_2Xj {
  display: flex;
  flex-direction: column;
  background-color: var(--f5-background);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px var(--_0000001a-shadow);
  width: 559px;
  max-width: 559px;
  transform: scale(1);
  animation: scaleUp_sIQ0F 300ms ease-out forwards;
  font-family: "Inter", sans-serif;
  @media (width <= 768px) {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
  }
}

.scaleDown_QOoi3 {
  animation: scaleDown_QOoi3 300ms ease-in forwards;
}

@keyframes scaleUp_sIQ0F {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_QOoi3 {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}

.fadeOut_lvu65 {
  opacity: 0;
  pointer-events: none;
}

.headerLeft_izJ0f {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 33px;
}
.closeIcon_iIZdj {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.footerContainer__fp8I {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 50px;
  gap: 16px;
}

.newFolderButton_zOEoT {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--_232222-color);
  padding: 12.5px 24px;
  border-radius: 8px;
  border: 1px solid var(--cb-border);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.selectButton_Sfnar {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-background);
  padding: 12.5px 24px;
  border-radius: 8px;
  background: var(--_10a37f-background);
  border: 1px solid var(--_10a37f-border);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.contentContainer_nq7Sl {
  display: flex;
  flex-direction: column;
  padding: 20px 15px;
  max-height: 55vh;
  overflow-y: auto;
  background: var(--white-background);
  min-height: 20vh;
  border-radius: 8px;
  gap: 22px;
  border: 1px solid var(--ececf1-border);
}
.contentContainer_nq7Sl::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contentContainer_nq7Sl::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}
.contentContainer_nq7Sl::-webkit-scrollbar-track {
  background: transparent;
}

.backButton_M2tDz {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 23px;
  height: 23px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: var(--_10a37f-background);
}

.inputTitle_oXYBS {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  margin-top: 0;
}

.cardTypesContainer_vJyDg {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}
.singleTypeCard_Hwjio {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid var(--e0e3e6-border);
  span {
    font-size: 12px;
    font-weight: 400;
    color: var(--_2a2e32-color);
    -webkit-user-select: none;
            user-select: none;
  }
}
.minusIcon_GdM1K {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: var(--dc3545-background);
  display: flex;
  align-items: center;
  justify-content: center;
}


.filterSection_mnttA {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  .checktypes_YFWhf {
    display: flex;
    align-items: center;
    gap: 15px;
    color: var(--_71717a-color);
    font-size: 13px;
    input[type="checkbox"] {
      accent-color: var(--_233f39-color);
    }
  }
}

.searchContainer_XVhCm {
  position: relative;
  display: flex;
  align-items: center;
}

.searchContainer_XVhCm img {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  pointer-events: none;
}
.searchContainer_XVhCm input {
  padding-left: 30px;
}

.input_jjgrK {
  padding-left: 35px;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--ea-background);
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  background-color: var(--f5-background);
}

.input_jjgrK::placeholder {
  color: var(--_9-color);
}

.searchAmount_E6x1K {
  display: flex;
  justify-content: space-between;
}

.select_pnCdC {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--ea-background);
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background-color: var(--f5-background);
}

.amountContainer_KZLDi {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.amountInput_JtB8p {
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 4px;
  height: 31px;
  gap: 10px;
  padding: 0 12px;
  flex: 1 1;
  box-sizing: border-box;
  min-width: 0;
  background-color: var(--f4-background);
  input {
    background-color: transparent;
  }
}


.amountInput_JtB8p input {
  border: none;
  width: 50%;
  font-size: 14px;
  color: var(--_1e0045-color);
  font-weight: 400;
}

.amountInput_JtB8p input:focus {
  outline: none;
}

.currencyContainer_y6mSY {
  color: var(--_264f88-color);
  font-weight: bold;
  border-bottom: 2px solid var(--_264f88-border);
  gap: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  div {
    gap: 5px;
  }
}

.currencyDropdownButton_QyhQe {
  display: flex;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.chevronIcon_Mr7uj {
  margin-top: 3px;
}
.currencyDropdown_qUvke {
  position: absolute;
  top: 97%;
  left: -4%;
  width: 108%;
  display: flex;
  flex-direction: column;
  background-color: var(--f4-background);
  border-radius: 4px;
  color: var(--_264f88-color);
  font-size: 14px;
  box-shadow: 0 2px 4px var(--_0000001a-shadow);
  z-index: 1;
  overflow: hidden;

  span {
    display: flex;
    padding: 1px 2px;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    justify-content: flex-start;
    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.inputContainer_FZVyK {
  border-radius: 3px;
  display: flex;
  font-family: "Inter", sans-serif;
  justify-content: space-between;
  align-items: center;
  background: var(--f5-background);
  padding: 0 12px;
}

.inputWithTitle_MZAJd {
  outline: none;
  border: none;
  padding-right: 16px;
  font-family: "Inter", sans-serif !important;
  width: 100%;
  margin-left: 8px;
  background: transparent;
  &::placeholder {
    font-size: 13px;
    font-weight: 300 !important;
  }
}

.inputWithTitle_MZAJd::-webkit-inner-spin-button,
.inputWithTitle_MZAJd::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.tagsContainer_SWAfU {
  display: flex;
  gap: 8px;
  margin: 9px 0;
  flex-wrap: wrap;
}
.singleTag_DUHAQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  height: 31px;
  gap: 5px;
  font-size: 14px;
  font-weight: 600;
  color: var(--white-background);
  padding: 0 6px 0 12px;
}
.keyWordContainer_JO_6k {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;
}
.keyword_QUfGS {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid var(--e0e3e6-border);
  align-items: center;
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FilesFilterModal/FilesFilterModal.module.css"],"names":[],"mappings":"AAAA,qGAAqG;AACrG;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gDAA0C;EAC1C,gCAAgC;EAChC;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,iDAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf;MACE,kCAAkC;IACpC;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;EACtC;IACE,6BAA6B;EAC/B;AACF;;;AAGA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,8CAA8C;EAC9C,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;;EAEhB;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;IAC3B;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB;IACE,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_00000066-background);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n  transition: opacity 300ms ease-in-out;\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f5-background);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n  width: 559px;\n  max-width: 559px;\n  transform: scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  font-family: \"Inter\", sans-serif;\n  @media (width <= 768px) {\n    width: 100vw;\n    max-width: 100vw;\n    height: 100vh;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n  }\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 33px;\n}\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.footerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  height: 50px;\n  gap: 16px;\n}\n\n.newFolderButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--_232222-color);\n  padding: 12.5px 24px;\n  border-radius: 8px;\n  border: 1px solid var(--cb-border);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n.selectButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-background);\n  padding: 12.5px 24px;\n  border-radius: 8px;\n  background: var(--_10a37f-background);\n  border: 1px solid var(--_10a37f-border);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 15px;\n  max-height: 55vh;\n  overflow-y: auto;\n  background: var(--white-background);\n  min-height: 20vh;\n  border-radius: 8px;\n  gap: 22px;\n  border: 1px solid var(--ececf1-border);\n}\n.contentContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.contentContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n.contentContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.backButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  width: 23px;\n  height: 23px;\n  cursor: pointer;\n  user-select: none;\n  background: var(--_10a37f-background);\n}\n\n.inputTitle {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 5px;\n  margin-top: 0;\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid var(--e0e3e6-border);\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--_2a2e32-color);\n    user-select: none;\n  }\n}\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: var(--dc3545-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.filterSection {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  .checktypes {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    color: var(--_71717a-color);\n    font-size: 13px;\n    input[type=\"checkbox\"] {\n      accent-color: var(--_233f39-color);\n    }\n  }\n}\n\n.searchContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.searchContainer img {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 15px;\n  height: 15px;\n  pointer-events: none;\n}\n.searchContainer input {\n  padding-left: 30px;\n}\n\n.input {\n  padding-left: 35px;\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--ea-background);\n  border-radius: 6px;\n  font-size: 14px;\n  box-sizing: border-box;\n  outline: none;\n  background-color: var(--f5-background);\n}\n\n.input::placeholder {\n  color: var(--_9-color);\n}\n\n.searchAmount {\n  display: flex;\n  justify-content: space-between;\n}\n\n.select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--ea-background);\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  background-color: var(--f5-background);\n}\n\n.amountContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.amountInput {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  border-radius: 4px;\n  height: 31px;\n  gap: 10px;\n  padding: 0 12px;\n  flex: 1;\n  box-sizing: border-box;\n  min-width: 0;\n  background-color: var(--f4-background);\n  input {\n    background-color: transparent;\n  }\n}\n\n\n.amountInput input {\n  border: none;\n  width: 50%;\n  font-size: 14px;\n  color: var(--_1e0045-color);\n  font-weight: 400;\n}\n\n.amountInput input:focus {\n  outline: none;\n}\n\n.currencyContainer {\n  color: var(--_264f88-color);\n  font-weight: bold;\n  border-bottom: 2px solid var(--_264f88-border);\n  gap: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  div {\n    gap: 5px;\n  }\n}\n\n.currencyDropdownButton {\n  display: flex;\n  gap: 5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n.chevronIcon {\n  margin-top: 3px;\n}\n.currencyDropdown {\n  position: absolute;\n  top: 97%;\n  left: -4%;\n  width: 108%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f4-background);\n  border-radius: 4px;\n  color: var(--_264f88-color);\n  font-size: 14px;\n  box-shadow: 0 2px 4px var(--_0000001a-shadow);\n  z-index: 1;\n  overflow: hidden;\n\n  span {\n    display: flex;\n    padding: 1px 2px;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    justify-content: flex-start;\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.inputContainer {\n  border-radius: 3px;\n  display: flex;\n  font-family: \"Inter\", sans-serif;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--f5-background);\n  padding: 0 12px;\n}\n\n.inputWithTitle {\n  outline: none;\n  border: none;\n  padding-right: 16px;\n  font-family: \"Inter\", sans-serif !important;\n  width: 100%;\n  margin-left: 8px;\n  background: transparent;\n  &::placeholder {\n    font-size: 13px;\n    font-weight: 300 !important;\n  }\n}\n\n.inputWithTitle::-webkit-inner-spin-button,\n.inputWithTitle::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.tagsContainer {\n  display: flex;\n  gap: 8px;\n  margin: 9px 0;\n  flex-wrap: wrap;\n}\n.singleTag {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 4px;\n  height: 31px;\n  gap: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--white-background);\n  padding: 0 6px 0 12px;\n}\n.keyWordContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 10px 0;\n}\n.keyword {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid var(--e0e3e6-border);\n  align-items: center;\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `modalOverlay_RR__W`,
	"modalContent": `modalContent_z_2Xj`,
	"scaleUp": `scaleUp_sIQ0F`,
	"scaleDown": `scaleDown_QOoi3`,
	"fadeOut": `fadeOut_lvu65`,
	"headerLeft": `headerLeft_izJ0f`,
	"closeIcon": `closeIcon_iIZdj`,
	"footerContainer": `footerContainer__fp8I`,
	"newFolderButton": `newFolderButton_zOEoT`,
	"selectButton": `selectButton_Sfnar`,
	"contentContainer": `contentContainer_nq7Sl`,
	"backButton": `backButton_M2tDz`,
	"inputTitle": `inputTitle_oXYBS`,
	"cardTypesContainer": `cardTypesContainer_vJyDg`,
	"singleTypeCard": `singleTypeCard_Hwjio`,
	"minusIcon": `minusIcon_GdM1K`,
	"filterSection": `filterSection_mnttA`,
	"checktypes": `checktypes_YFWhf`,
	"searchContainer": `searchContainer_XVhCm`,
	"input": `input_jjgrK`,
	"searchAmount": `searchAmount_E6x1K`,
	"select": `select_pnCdC`,
	"amountContainer": `amountContainer_KZLDi`,
	"amountInput": `amountInput_JtB8p`,
	"currencyContainer": `currencyContainer_y6mSY`,
	"currencyDropdownButton": `currencyDropdownButton_QyhQe`,
	"chevronIcon": `chevronIcon_Mr7uj`,
	"currencyDropdown": `currencyDropdown_qUvke`,
	"inputContainer": `inputContainer_FZVyK`,
	"inputWithTitle": `inputWithTitle_MZAJd`,
	"tagsContainer": `tagsContainer_SWAfU`,
	"singleTag": `singleTag_DUHAQ`,
	"keyWordContainer": `keyWordContainer_JO_6k`,
	"keyword": `keyword_QUfGS`
};
export default ___CSS_LOADER_EXPORT___;
